import { UserModel } from 'src/services/redux/slices/auth/models/UserModel';
import { Permission } from './types';

const fetchPermission =
  (user: UserModel | any) =>
  async (permission: Permission): Promise<boolean> => {
    return user.roles.includes(permission);
  };
export default fetchPermission;
